import {config} from "./config";
import {request} from "./request";

function createTaokeAppKey(data, cb, fail_cb) {
    request.post.call(this, config.apiList.taokeAppKey, data, {}, cb, fail_cb)
}

function getTaokeAppKey(data, cb, fail_cb) {
    request.get.call(this, config.apiList.taokeAppKey, data, cb, fail_cb)
}

var taokeAppKeyApi = {
    createTaokeAppKey: createTaokeAppKey,
    getTaokeAppKey: getTaokeAppKey
}

export {taokeAppKeyApi}